import api from './api';

export interface DeliveryCity {
  id: string;
  cnpj: string;
  name: string;
  state: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ListDeliveryCitiesParams {
  searchTerm?: string;
  state?: string;
  isActive?: boolean;
  cnpj?: string;
}

export interface CreateDeliveryCityPayload {
  name: string;
  state: string;
  isActive?: boolean;
  cnpj?: string;
}

export interface UpdateDeliveryCityPayload {
  name?: string;
  state?: string;
  isActive?: boolean;
  cnpj?: string;
}

const normalizeCity = (data: any): DeliveryCity => ({
  id: String(data.id ?? ''),
  cnpj: String(data.cnpj ?? ''),
  name: String(data.name ?? ''),
  state: String(data.state ?? '').toUpperCase(),
  isActive: Boolean(data.isActive ?? true),
  createdAt: String(data.createdAt ?? new Date().toISOString()),
  updatedAt: String(data.updatedAt ?? new Date().toISOString()),
});

export const deliveryCityService = {
  async list(params: ListDeliveryCitiesParams = {}): Promise<DeliveryCity[]> {
    const response = await api.get('/admin/delivery/cities', {
      params: {
        searchTerm: params.searchTerm?.trim() || undefined,
        state: params.state?.trim().toUpperCase() || undefined,
        isActive: params.isActive,
        cnpj: params.cnpj?.trim() || undefined,
      },
    });

    const payload = Array.isArray(response.data) ? response.data : [];
    return payload.map(normalizeCity);
  },

  async get(id: string, cnpj?: string): Promise<DeliveryCity> {
    const response = await api.get(`/admin/delivery/cities/${id}`, {
      params: {
        cnpj: cnpj?.trim() || undefined,
      },
    });

    return normalizeCity(response.data);
  },

  async create(payload: CreateDeliveryCityPayload): Promise<DeliveryCity> {
    const response = await api.post(
      '/admin/delivery/cities',
      {
        name: payload.name.trim(),
        state: payload.state.trim().toUpperCase(),
        isActive: payload.isActive,
      },
      {
        params: {
          cnpj: payload.cnpj?.trim() || undefined,
        },
      },
    );

    return normalizeCity(response.data);
  },

  async update(id: string, payload: UpdateDeliveryCityPayload): Promise<DeliveryCity> {
    const response = await api.put(
      `/admin/delivery/cities/${id}`,
      {
        name: payload.name?.trim(),
        state: payload.state?.trim().toUpperCase(),
        isActive: payload.isActive,
      },
      {
        params: {
          cnpj: payload.cnpj?.trim() || undefined,
        },
      },
    );

    return normalizeCity(response.data);
  },

  async delete(id: string, cnpj?: string): Promise<void> {
    await api.delete(`/admin/delivery/cities/${id}`, {
      params: {
        cnpj: cnpj?.trim() || undefined,
      },
    });
  },
};

export default deliveryCityService;
